module.exports = __webpack_public_path__ + "img/icon_map_38_off_100.28713c55.png";